enum AnalyticsEvent {
    ExpandButtonClicked = 'Expand button clicked',
    SubscribeToExpandClicked = 'Expand Visualization > Subscribe-to-access clicked',
    SubscribeToExportClicked = 'Export Visualization > Subscribe-to-access clicked',
    SubscribeToShareClicked = 'Share Visualization > Subscribe-to-access clicked',
    ExportResultsCsv = 'Export execution results > csv clicked',
    ExportResultsJson = 'Export execution results > json clicked',
    CopyImageClicked = 'Copy image clicked',
    DownloadImageClicked = 'Download image clicked',
    LegendItemClicked = 'Legend item clicked',
}

export { AnalyticsEvent };
